import { DefaultFooter } from '@ant-design/pro-components';
import { Space, Typography } from 'antd';
import React from 'react';

const { Link, Text } = Typography;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`Copyright © ${currentYear} Lihuhu Games. All Rights Reserved.`}
      links={[
        {
          key: 'company',
          title: 'Lihuhu Games',
          href: 'https://lihuhugames.com',
          blankTarget: true,
        },
        {
          key: 'support',
          title: 'Technical Support',
          href: 'mailto:duy.tran@lihuhugames.com;huy.mai@lihuhugames.com',
        },
        {
          key: 'version',
          title: (
            <Space>
              <Text type="secondary">Version:</Text>
              <Text strong>1.0.0</Text>
            </Space>
          ),
          href: '#',
        },
        {
          key: 'docs',
          title: 'Documentation',
          href: '/docs',
        },
      ]}
    />
  );
};

export default Footer;
